import React, { useState } from "react";
import { Dialog, DialogContent, IconButton, Switch } from "@mui/material";
import styles from "../../styles/settings/settings.module.css";
import { useUser } from "../../context/AuthContext";
import PolicyPage from "../Policies/PolicyPage";
import TermsOfServices from "../Policies/TermsOfServices";
import CloseIcon from "@mui/icons-material/Close";

const Setting = () => {
  const { user } = useUser();
  console.log("user", user);
  const [active, setActive] = useState({
    email: true,
    push: true,
  });

  const [activeDialog, setActiveDialog] = useState(null);

  const handleCloseDialog = () => {
    setActiveDialog(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  const notificationOptions = [
    // { key: "email", label: "Email Notifications" },
    { key: "push", label: "Push Notifications" },
  ];

  const handleToggle = (type) => {
    setActive((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  return (
    <div className={styles.main}>
      <p className={styles.heading}>Settings</p>

      <div className={styles.container}>
        <div>
          <p className={styles.container_heading}>Account Information</p>
          <p className={styles.container_subheading}>
            Name: {user?.name ?? "-"}
          </p>
          <p className={styles.container_subheading}>
            Email: {user?.email ?? "-"}
          </p>
        </div>
        {/* <button className={styles.button_active}>Edit Info</button> */}
      </div>

      <div className={styles.amount_container}>
        <div>
          <p className={styles.container_heading}>Notification Control</p>
          <div className={styles.notification_item}>
            {notificationOptions.map((option) => (
              <div key={option.key} className={styles.notification_div}>
                <p className={styles.container_subheading}>{option.label}</p>
                <Switch
                  checked={active[option.key]}
                  onChange={() => handleToggle(option.key)}
                  color="primary"
                  sx={{ marginTop: "-0.75rem" }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.container}>
        <div>
          <p className={styles.container_heading}>
            Company Profile Information
          </p>
          <p className={styles.container_subheading}>
            Company Name: {user?.company?.companyName ?? "-"}
          </p>
          <p className={styles.container_subheading}>
            Address : {user?.company?.companyAddress ?? "-"}
          </p>
        </div>
        {/* <button className={styles.button_active} disabled>
          Edit Company Info
        </button> */}
      </div>

      <div className={styles.subscription_container}>
        <p className={styles.container_heading}>Subscription Info</p>
        <p className={styles.container_subheading}>
          Current Plan :
          <span>
            <button className={styles.button_subscription}>Regular</button>
          </span>
        </p>
        <button className={styles.button_active}>Upgrade Plan</button>
      </div>

      <div className={styles.subscription_container}>
        <p className={styles.container_heading}>Account Information</p>
        <span
          className={styles.terms_heading}
          onClick={(e) => {
            e.preventDefault();
            // setIsPolicyOpen(true);
            setActiveDialog("policy");
          }}
        >
          Privacy Policy
        </span>
        <span
          style={{
            color: "rgba(226, 226, 226, 1)",
          }}
        >
          {" "}
          |{" "}
        </span>{" "}
        <span
          className={styles.terms_heading}
          onClick={(e) => {
            e.preventDefault();
            // setIsTermsOpen(true);
            setActiveDialog("terms");
          }}
        >
          {" "}
          Terms of Service
        </span>
      </div>

      {/* <Dialog
        key={activeDialog} 
        open={Boolean(activeDialog)}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        BackdropProps={{
          style: {
            backgroundColor: "rgba(255, 255, 255, 0.5)", 
            backdropFilter: "blur(4px)", 
            WebkitBackdropFilter: "blur(4px)", 
          },
        }}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "visible",
            maxHeight: "80vh",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "fixed",
            right: "10rem",
            top: "4rem",
            zIndex: 9999,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(2px)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: 0, overflow: "auto" }}>
          {activeDialog === 'policy' && <PolicyPage />}
          {activeDialog === 'terms' && <TermsOfServices />}
        </DialogContent>
      </Dialog> */}

      <Dialog
        key={activeDialog}
        open={Boolean(activeDialog)}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        BackdropProps={{
          style: {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)",
          },
        }}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "hidden", // Changed from "visible"
            display: "flex",
            flexDirection: "column",
            // Removed maxHeight constraint
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "absolute", // Changed from "fixed"
            right: "1rem", // More reasonable positioning
            top: "1rem",
            zIndex: 9999,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(2px)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent
          sx={{
            p: 0,
            overflow: "hidden", // Changed from "auto"
            height: "auto", // Ensure content defines height
          }}
        >
          {activeDialog === "policy" && <PolicyPage height="90vh" />}
          {activeDialog === "terms" && <TermsOfServices height="90vh" />}
        </DialogContent>
      </Dialog>

      <div className={styles.logout_container}>
        <button className={styles.logout_button} onClick={handleLogout}>
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Setting;
